import { useCallback, useMemo } from "react"
import { Form, Input, DatePicker, Button } from 'antd'
import moment from "moment"
import BlockComplex from '@/components/BlockComplex'
import * as api from '@/api/workbench'
import ZtTag from '@/pages/Workbench/components/WorkList/components/ZtTag'

const Comp = () => {

  const handleApprove = useCallback(() => {
    window.openInnerPage('/xmk/xmgl/xmk/xmjsNew/skglNew?fpzt=1', '收款管理')
  }, [])

  const columns = useMemo(() => {
    return [
      { title: '记账状态', width: 100, dataIndex: 'FPZT', ellipsis: true, render(text) {
        return <ZtTag text={text} />
      } },
      {
        title: '收款编号', 
        width: 150, 
        dataIndex: 'DH',
        ellipsis: true,
      },
      { title: '流水号', width: 150, dataIndex: 'LSH', ellipsis: true },
      { title: '付款单位', width: 150, dataIndex: 'FKDW', ellipsis: true },
      { title: '收款日期', width: 100, dataIndex: 'SKRQ', ellipsis: true, render(text) {
        if(!text) {
          return ''
        }
        return moment(text).format('YYYY-MM-DD')
      } },
      { title: '收款方式', width: 100, dataIndex: 'SKFS', ellipsis: true },
      { title: '收款金额', width: 100, dataIndex: 'SKJE', ellipsis: true },
      { title: '收款人', width: 100, dataIndex: 'SKR', ellipsis: true },
      {
        title: '操作', 
        width: 60, 
        dataIndex: 'cz', 
        render() {
          return <Button type="link" onClick={handleApprove}>记账</Button>
        }
      }
    ]
  }, [handleApprove])

  const query = useCallback((params) => {
    const skrq: any = {}
    if(params.skrq && params.skrq.length > 0) {
      skrq.skrqks = params.skrq[0].format('YYYY-MM-DD')
      skrq.skrqjs = params.skrq[1].format('YYYY-MM-DD')
    }
    return api.getCwsxDskjz({
      ...params,
      ...skrq,
      skrq: undefined
    })
  }, [])

  return (
    <div className="">
      <BlockComplex
        columns={columns}
        rowKey="DH"
        load={query}
        searchForm={
          <>
            <Form.Item
              label="收款编号"
              name="skbh"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
            <Form.Item
              label="付款单位"
              name="fkdw"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
            <Form.Item
              label="收款日期"
              name="skrq"
            >
              <DatePicker.RangePicker />
            </Form.Item>
          </>
        }
      />
    </div>
  )
}

export default Comp
